'use strict';

var DashboardPanelConfig = function DashboardPanelConfig($stateProvider) {
  $stateProvider.state('app.dashboard', {
    url: '/workflow/dashboard',
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: '<rm-dashboard-panel></rm-dashboard-panel>'
      },
      'mainToolbar': {
        template: require('../templates/dashboard-toolbar.html'),
        controller: 'DashboardToolbarController'
      }
    }
  });
};
module.exports = DashboardPanelConfig;
DashboardPanelConfig.$inject = ['$stateProvider'];